import { useQuery } from '@tanstack/react-query'

import { httpService } from '@/api/v1/http.service'

type Params = {
  studentId?: string[]
  dateBefore?: string
  dateAfter?: string
}

const useStudentAttendanceIds = (params: Params = {}, enabled = true) =>
  useQuery({
    queryKey: ['panelPlanAttendancesListIds', params],
    staleTime: 60 * 1000,
    queryFn: async () => {
      const response = await httpService.panel.panelAttendancesList({
        student_id: params.studentId,
        date_before: params.dateBefore,
        date_after: params.dateAfter,
        page: 1,
        page_size: 'max',
        presence: ['absent_unexcused', ''],
        ordering: 'date,start_time',
        fetchKeys: {
          id: true
        }
      })

      return response.results.map(item => item.id)
    },
    enabled
  })

export default useStudentAttendanceIds
